import { Menu } from 'omnisearch/build/shared';
import styled, { css } from 'styled-components';

import { rem } from '@vimeo/bokeh';
import { bokehTheme as theme } from '@vimeo/bokeh-theme';
import { Badge } from '@vimeo/iris/components';
import { ArrowReply } from '@vimeo/iris/icons';
import { core } from '@vimeo/iris/tokens';

const activeStyle = {
  background: theme.colors.gray['50'],
};

export const activeMyVideosStyle = {
  ...activeStyle,
  borderRadius: '4px',
  position: 'relative',
};

export const EXPANDED_SEARCH_WIDTH = 500;
export const PADDING_FOR_MODE_SWITCHER = 50;

export const StyledNoticeWrapper = styled.div`
  margin: ${rem(10)} ${rem(21)} 0;
  p {
    font-size: ${rem(13)};
  }
  div {
    margin-bottom: 0;
  }
  span[format] {
    top: 0.85rem;
    left: 0.75rem;
  }
`;

export const StyledNewBadge = styled(Badge)`
  margin-top: 0;
  background-color: #1140c6;
  color: ${theme.colors.white};
`;

export const StyleMenu = styled(Menu)`
  ${core.edge(600)};
`;

export const StyledArrowReply = styled(ArrowReply)<{ hasMoments?: boolean }>`
  transform: scale(-1, 1);

  path {
    fill: ${({ theme, hasMoments }) =>
      hasMoments &&
      css`
        ${theme.name === 'light' ? '#3D4751' : core.color.text.secondary} !important
      `};
  }
`;
